var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-empty-content",class:`x-empty-content--type-${_vm.type}`},[_c('div',{staticClass:"x-empty-content--image"}),(_vm.computedLabel)?_c('x-ellipsis',{staticClass:"x-empty-content--label",attrs:{"row":1}},[_vm._v(" "+_vm._s(_vm.computedLabel)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }